import { Navigate } from "react-router-dom";
import PermissionGuard from "src/components/PermissionGuard";
import { usePlanPermissions } from "src/hooks/usePlanPermissions";

/**
 * Proteção de toda página da Berta:
 *  1. chave de plano `berta` (default false) — sem ela, volta para a home;
 *  2. PermissionGuard com a permissão granular da página (só afeta filiados).
 * O backend repete as duas checagens (checkPlanFeature + checkPermission).
 */
export default function BertaGuard({ permissionKey = "berta", children }) {
  const planPerms = usePlanPermissions();
  if (!planPerms.berta) return <Navigate to="/extended-sidebar/menu/home" replace />;
  return (
    <PermissionGuard permissionKey="berta">
      <PermissionGuard permissionKey={permissionKey}>{children}</PermissionGuard>
    </PermissionGuard>
  );
}
